export default __webpack_public_path__ + "static/latitude-reward-image-banner-desktop-7ae46d6773de9288fef664c8054fde2f.png";